(ns iris.indexeddb
  (:require
   ["localbase" :default Localbase]
   [re-frame.core :as re-frame]
   [cljs.core.async :refer [go <!]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [iris.firebase :as fb]
   [iris.events :as events]
   [iris.globals :as globals]))


(def db (new Localbase "Iris"))
(set! (.. db -config -debug) false)

(def raid-col "raids")
(def raid-cache-id-col "raids-cache-id")

;; TODO: possibly rename to "ref-previews" or "posts-ref-previews"
(def ref-preview-col "ref-previews")

(defn add-ref-preview [ruid data]
  (->
   (.collection db ref-preview-col)
   (.add data ruid) ))

(defn get-ref-preview [ruid]
  (new js/Promise (fn [resolve _]
                    (->
                     (.collection db ref-preview-col)
                     (.doc ruid)
                     (.get)
                     (.then (fn [^js res]
                              (if (not res)
                                (resolve nil)
                                (resolve res))))))))





(defn add-raid [eid raid]
  (->
   (.collection db raid-col)
   (.add #js {:raid raid} eid)))


(defn get-raid [eid]
  (new js/Promise (fn [resolve _]
                    (->
                     (.collection db raid-col)
                     (.doc eid)
                     (.get)
                     (.then (fn [^js res]
                              (if (not res)
                                (resolve nil)
                                (resolve (.-raid res)))))))))


(defn set-raid-cache-id [id]
    (new js/Promise (fn [resolve _]
                      (->
                       (.collection db raid-cache-id-col)
                       (.doc "cache-id")
                       (.set #js {:id id})
                       (.then (fn [res]
                                (resolve res)))))))

(defn get-raid-cache-id []
  (new js/Promise (fn [resolve _]
                    (->
                     (.collection db raid-cache-id-col)
                     (.doc "cache-id")
                     (.get)
                     (.then (fn [^js res]
                              (if (not res)
                                (resolve nil)
                                (resolve (.-id res)))))))))

(defn delete-raids-col []
  (new js/Promise (fn [resolve _]
                    (-> (.collection db raid-col)
                        (.delete)
                        (.then (fn [res]
                                 (resolve res)))))))




(defn on-update-raid-cache-id [data]
  (go
    (let [ts (<p! (get-raid-cache-id))
          new-ts (:datetime data)]
      (re-frame/dispatch [::events/set-raids-cache-id new-ts])
      (when (not= ts new-ts)
        (<p! (set-raid-cache-id new-ts))
        (<p! (delete-raids-col))))))

;; TODO: turn this back on needed for raid purging. turned off because it stops app from loading
;; (go
;;   (fb/bind-raid-cache-id on-update-raid-cache-id))

;; (defn go-raid-cache-id []
;;   (go
;;     (let [user (<! (fb/wait-for-auth-user))]
;;       ;; Safe to use Firebase Realtime DB now
;;       (js/console.log "Now operating as:" (.-uid user))
;;       (fb/bind-raid-cache-id on-update-raid-cache-id))))

;; NOTE: 04/19/2024 raid cache id no longer needed
;; (swap! globals/exec-on-fb-sign-in #(conj @globals/exec-on-fb-sign-in go-raid-cache-id))



;; ;; check for IndexedDB support
;; (defn idb-support? []
;;   (if (. js/window -indexedDB)
;;     true
;;     false))


;; (when-not (idb-support?)
;;   (println "Your browser does not support IndexedDB"))


;;;;;;;;;;;;;;;
;; Autotags
;;;;;;;;;;;;;;;

(def autotags-cache-key "autotags-data")
(def autotags-cache-expiry-ms (* 60 60 1000)) ; 1 hour

(defn set-autotags-cache! [ws data]
  (->
   (.collection db "autotags-cache")
   (.doc (str ws "-" autotags-cache-key))
   (.set #js {:data      (clj->js data)
              :timestamp (.now js/Date)})))

(defn get-autotags-cache! [ws callback]
  (-> (.collection db "autotags-cache")
      (.doc (str ws "-" autotags-cache-key))
      (.get)
      (.then (fn [res]
               (if (.-timestamp res)
                 (callback (js->clj res :keywordize-keys true))
                 (callback nil))))
      (.catch (fn [_] (callback nil)))))

